
import styled from 'styled-components';

import { COLORS } from '../../../../constants/colors';

export const RestoreWrapper = styled.div`
   margin: 20px;
   justify-content: flex-start;
   align-self: stretch;
   overflow-x: hidden;
   overflow-y: scroll;
`

export const CourseTitle = styled.h1`
   color: ${COLORS.urbanBlack};
`

export const CourseSubtitle = styled.div`
   color: ${COLORS.urbanBlack};
   font-weight: 400;
   font-size: 14px;
   line-height: 20px;
   max-width: 500px;
`

export const CourseFooter = styled.div<{ isMobile: boolean }>`
   display: flex;
   justify-content: space-between;
   flex-direction: ${({ isMobile }) => isMobile ? 'column' : 'row'};
   gap: 4rem;
`

export const CoursePlanWrapper = styled.div<{ isMobile: boolean }>`
   display: flex;
   margin: ${({ isMobile }) => isMobile ? '20px 0' : '50px'};
   align-items: ${({ isMobile }) => isMobile ? 'flex-start' : 'center'}};
   flex-direction: ${({ isMobile }) => isMobile ? 'column' : 'row'};
   gap: ${({ isMobile }) => isMobile ? '2rem' : '10rem'};
   text-align: left;

   p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      max-width: 400px;
   }

   img {
      filter: ${({ isMobile }) => isMobile ? 'none' : 'drop-shadow(12px 12px 27px rgba(0, 0, 0, 0.25))'};
      width: ${({ isMobile }) => isMobile ? '100%' : 'auto'};
   }
`

export const ChatDecorationWrapper = styled.div<{ isMobile: boolean, isSmallScreen: boolean }>`
   margin-top: ${({ isMobile }) => isMobile ? '20px' : ''};
   background: ${({ isSmallScreen }) => isSmallScreen ? COLORS.urbanBlack : ''};
   padding: ${({ isMobile }) => isMobile ? '10px' : '10px 0px'};
   margin: ${({ isMobile }) => isMobile ? '20px 0px' : '20px 0px'};
   border-radius: ${({ isMobile }) => isMobile ? '10px' : '0'};

   img {
      margin-top: -100px;
      width: 100%;
      display: ${({ isSmallScreen }) => isSmallScreen ? 'none' : 'block'};
   }
`

export const ChatTitle = styled.h1<{ isMobile: boolean, isSmallScreen: boolean }>`
   color: ${COLORS.white};
   position: ${({ isMobile }) => isMobile ? 'unset' : 'relative'};
   top: ${({ isSmallScreen }) => isSmallScreen ? '0px' : '110px'};
   left: 30px;
`

export const ChatSubtitle = styled.p<{ isMobile: boolean, isSmallScreen: boolean }>`
   color: ${COLORS.white};
   position: ${({ isMobile }) => isMobile ? 'unset' : 'relative'};
   top: ${({ isSmallScreen }) => isSmallScreen ? '0px' : '110px'};
   left: 30px;
`

export const ButtonWrapper = styled.div<{ isMobile: boolean, isSmallScreen: boolean }>`
   color: ${COLORS.white};
   position: ${({ isMobile }) => isMobile ? 'unset' : 'relative'};
   top: ${({ isSmallScreen }) => isSmallScreen ? '' : '-110px'};
   left: 30px;
`

export const HoveredImageWrapper = styled.div`
   display: flex;
   justify-content: space-around;
   align-items: center;

   img {
      max-width: 190px;
   }
`

export const ImagesWrapper = styled.div<{ isMobile: boolean }>`
   display: ${({ isMobile }) => isMobile ? 'none' : 'flex'};
   justify-content: space-around;
   
   align-items: center;

   img {
      max-width: 190px;
      margin: 10px;
   }
`
